import { render, staticRenderFns } from "./RegisterFormPage.vue?vue&type=template&id=2edfb64a&scoped=true&"
import script from "./RegisterFormPage.vue?vue&type=script&lang=js&"
export * from "./RegisterFormPage.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFormPage.vue?vue&type=style&index=0&id=2edfb64a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edfb64a",
  null
  
)

export default component.exports